import { render, staticRenderFns } from "./SysMessageTemplateModal.vue?vue&type=template&id=51a812cd&scoped=true"
import script from "./SysMessageTemplateModal.vue?vue&type=script&lang=js"
export * from "./SysMessageTemplateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a812cd",
  null
  
)

export default component.exports